import { 
    apiBizGetAccountList,
    apiBizGetAccountInfo,
    apiBizInsertAccount,
    apiBizDelAccount,
    apiBizEditAccount,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_account_list: 'internalAuth/accountMgt/set_account_list',
    set_account_info: 'internalAuth/accountMgt/set_account_info',
    set_account_filter_word: 'internalAuth/accountMgt/set_account_filter_word',
}

// count state 必須是 Object
const state = {
    accountList: [],
    accountInfo: [],
    filter: {
        word: null,
        options: {

        }
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_ACCOUNT_LIST: (state) => {
        return state.accountList
    },
    GET_BIZ_ACCOUNT_INFO: (state) => {
        return state.accountInfo
    },
    GET_BIZ_ACCOUNT_FILTER_WORD: (state) => {
        return state.filter.word
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    // 取得帳號列表
    getBizAccountList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetAccountList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.length > 0){
                        commit(types.set_account_list, res.data.result);
                        resolve()
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 取得單一帳號
    getBizAccountInfo ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetAccountInfo(value)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_account_info, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 新增帳號
    insertBizAccount ( {commit,dispatch} , value ) {
        return new Promise((resolve, reject) => {
            apiBizInsertAccount(value)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 編輯帳號
    editBizAccount ( {commit,dispatch} , value ) {
        return new Promise((resolve, reject) => {
            apiBizEditAccount(value)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 刪除帳號
    delBizAccount ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizDelAccount(value)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve(res)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 設定搜尋文字
    setlBizAccountFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_account_filter_word, value);
            
        })
    },
}

// mutations
const mutations = {
    [types.set_account_list](state, data){
        state.accountList = data
    },
    [types.set_account_info](state, data){
        state.accountInfo = data
    },
    [types.set_account_filter_word](state, data){
        state.filter.word = data
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/internalAuth/accountMgt/accountMgt.js